<template>
  <MainContent>
    <b-card>
      <nx-bform @submit="onSubmit">
        <h5>
          {{ $t("forgetPasswordtitle") }}
        </h5>
        <!-- <nx-bform-server-errors name="server-errors" /> -->
        <div class="mb-2" style="color:#dc3545;font-size: 80%;margin-top: 0.25rem;">
          {{errorMsg}}
        </div>

        <LoginNameFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.username"
          required
        />
        <LoginEmailFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.email"
          required
        />

        <b-form-group label-cols="2">
          <router-link :to="{ name: 'LoginForgetLoginName' }" class="bd-url">
            {{ $t("query.forgetLoginName") }}
          </router-link>
        </b-form-group>
        <b-form-group label-cols="2">
          <router-link :to="{ name: 'LoginActivationKeyView' }" class="bd-url">
            {{ $t("query.activationKey") }}
          </router-link>
        </b-form-group>

        <b-form-group label-cols="2">
          <b-button type="submit" class="bd-button mr-2">{{ $t("reset") }}</b-button>
          <b-button variant="danger" @click="redirectLogin">{{$t('cancel')}}</b-button>
        </b-form-group>
      </nx-bform>
    </b-card>
  </MainContent>
</template>

<script>
import MainContent from "../../../components/main/MainContent";
import { UserApi } from "nx-libs";
import LoginNameFormGroup from "@/forms/login/LoginNameFormGroup";
import LoginEmailFormGroup from "@/forms/login/LoginEmailFormGroup";
import { translateResponseError } from "@/utils/translate-response-error";

export default {
  components: {
    MainContent,
    LoginNameFormGroup,
    LoginEmailFormGroup,
  },
  data() {
    return {
      form: {
        username: "",
        email: "",
      },
      errorMsg: ""
    };
  },
  methods: {
    async onSubmit() {
      this.errorMsg = "";
      try {
        await UserApi.forgetPassword(this.form.username, this.form.email);
        this.$successToast(
          this.$t("messages.successTitle"),
          this.$t("messages.successMsg")
        );
      } 
      catch(ex) {
        if (ex.response && ex.response.data != null) {
          this.errorMsg = translateResponseError(this, ex.response.data);
        }
        throw ex;
      }
    },
    redirectLogin() {
      this.$router.push({ name: 'Login' });
    },
  }
};
</script>

<style lang="scss"></style>

<i18n src="@/locales/actions.locale"></i18n>

<i18n src="@/locales/login.locale"></i18n>

<i18n src="@/locales/responseMsg.locale"></i18n>


<i18n>
{
  "en": {
    "forgetPasswordtitle": "Request reset password",
    "messages": {
      "successTitle": "Email sent",
      "successMsg": "Please reset the password according to the email"
    }
  },
  "zh_hk": {
    "forgetPasswordtitle": "要求重設密碼",
     "messages": {
       "successTitle": "郵件已發送",
       "successMsg": "請根據電子郵件重設密碼"
    }
  },
  "zh_cn": {
    "forgetPasswordtitle": "要求重设密码",
      "messages": {
      "successTitle": "邮件已发送",
      "successMsg": "请根据电子邮件重设密码"
    }
  }
}
</i18n>
